import { render, staticRenderFns } from "./ProductTechniquesList.vue?vue&type=template&id=6753cfdb&scoped=true&"
import script from "./ProductTechniquesList.vue?vue&type=script&lang=js&"
export * from "./ProductTechniquesList.vue?vue&type=script&lang=js&"
import style0 from "./ProductTechniquesList.vue?vue&type=style&index=0&id=6753cfdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6753cfdb",
  null
  
)

export default component.exports